/* istanbul ignore file */
import { SettingValues } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';
import { useMemo } from 'react';
import { extractInsightsByKeysFromSetting } from './insights.formatters';
import { INSIGHTS_KEYS } from '../insights.keys';
import { omitDeepKeys } from 'common/utils/utils';

const EXCLUDED_INSIGHTS = [
  `delivery_risk.insights.${INSIGHTS_KEYS.ISSUES_CARRIED_OVER_SPRINTS}`
];

const useInsightsSetting = () => {
  const { getSettingOrDefinitionValue, updateSetting } = useSettingsService();

  const value = getSettingOrDefinitionValue({
    name: SettingValues.PROJECT_PROGRESSION_INSIGHTS
  });
  const valueWithoutExcluded = useMemo(
    () => omitDeepKeys(value, EXCLUDED_INSIGHTS),
    [value]
  );

  const onSave = async settingPayload =>
    await updateSetting(
      SettingValues.PROJECT_PROGRESSION_INSIGHTS,
      settingPayload
    );

  const onDelete = async () =>
    await updateSetting(SettingValues.PROJECT_PROGRESSION_INSIGHTS, null);

  const insightsByKeys = useMemo(
    () => extractInsightsByKeysFromSetting(value),
    [value]
  );

  const getInsightByKey = insightKey => insightsByKeys[insightKey];

  return {
    value: valueWithoutExcluded,
    onSave,
    onDelete,
    getInsightByKey
  };
};

export default useInsightsSetting;
